<main>
  <div class="container">
    <app-logo class="logo-home"></app-logo>
    <app-search-bar></app-search-bar>
  </div>
</main>
